import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import ShieldCheckmarkIcon from '../../../../icons/shield-checkmark.svg';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import './ShowOtherOptions.scss';
import { SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, SESSION_STORAGE_HEALTH_CLASS_KEY, SESSION_STORAGE_TERM_LENGTH_KEY } from '../../../../sessionStorage'

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)"

const useStyles = makeStyles(theme => ({
  white: {
    color: theme.palette.primary.main,
    backgroundColor: white,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: offWhite
    },
    '&:focus': {
      outline: 'none'
    }
  },
  btnColor: {
    color: theme.palette.primary.main,
  }
}));

export default function ShowOtherOptions(props) {
  const classes = useStyles()

  const href = props.href ? props.href : '/quote/term-life-insurance/multi-carrier-term';
  const title = props.title || "SHOW OTHER OPTIONS";

  const setSessionStorage = (data) => {
    sessionStorage.setItem(SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, data.coverageAmount);
    sessionStorage.setItem(SESSION_STORAGE_HEALTH_CLASS_KEY, data.healthClass);
    sessionStorage.setItem(SESSION_STORAGE_TERM_LENGTH_KEY, data.terms);
  };

  return (
    <Button
      className={props.termAlternatives ? '' : `other-options-button ${classes.white}`}
      fullWidth
      type="submit"
      onClick={() => setSessionStorage(props)}
      href={href}
      variant={props.termAlternatives ? '' : "contained"}
    >
      {props.termAlternatives ? '' : <SvgIcon component={ShieldCheckmarkIcon} color="primary" />}
      <span className={props.termAlternatives ? `${classes.btnColor}` : "name"}>&nbsp;{title}</span>
    </Button>
  );
}

ShowOtherOptions.propTypes = {
  coverageAmount: PropTypes.number,
  href: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/ShowOtherOptions.js